console.log('2022122601');

/*
  VueComponents 
/*---------------------------------------*/
import store from './store';
import VueHazardmapComponent from '../vue/VueHazardmapComponent.vue';
import './vue-gtm';
// Vue.config.devtools = true

/*
  Page Init 
/*---------------------------------------*/
function init() {
  /*
    Hazard Map Component 
  /*---------------------------------------*/
  if (document.getElementById('map')) {
    new Vue({
      store,
      components: {
        VueHazardmapComponent,
      },
    }).$mount('#map');
  }
}
document.addEventListener('DOMContentLoaded', init);
